import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Loading from 'vue-loading-overlay';
import VueCookie from 'vue-cookie'
import 'vue-loading-overlay/dist/vue-loading.css';
import http from "@/http-common";
import Toast, { PluginOptions } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import Paginate from "vuejs-paginate-next";
import VueGtag from "vue-gtag";


const app = createApp(App);

app.use(router);
app.use(Loading, {
    color: '#48ABF7',
    loader: 'bars',
    width: 64,
    height: 64,
    backgroundColor: '#FFF',
    opacity: 0.8,
    zIndex: 999,
}, {});
const options: PluginOptions = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    timeout: 5000,
    closeOnClick: true,
    newestOnTop: true
};
app.use(Toast, options);
app.use(Paginate);
app.use(VueGtag, {
    config: { id: "UA-177540239-1" }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = VueCookie.get('customer_token')
        if (!token) {
            router.push({ name: 'Login'})
        } else {
            next()
        }
    } else {
        next() 
    }
});

http.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookie.get('customer_token');
app.mount('#app')


